// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"600":"13e02d83","960":"8ce0605b"}[chunkId] + ".chunk.css";
};